import { db } from "./firebase";
import { get, child, set, ref, update } from "firebase/database";
import { USER_PAYMENTS_FRECUENCY, USER_PAYMENT_PROVIDERS, USER_PLANS, createMenu, createUser } from "./structures";

export const storeIDIsAvailable = async ID => {
  const result = await fetchMenuByID(ID)

  if (!result) {
    return true
  } else {
    return false
  }
}

export function setProduct(userAuth, menuID, productID, product) {
  return set(ref(db, 'menus/' + menuID + '/products/' + productID), product);
}

export function setCategory(userAuth, menuID, position, categoryName) {
  return set(ref(db, 'menus/' + menuID + '/categories/' + position), categoryName);
}

export function setCategories(userAuth, menuID, newCategories) {
  return set(ref(db, 'menus/' + menuID + '/categories'), newCategories);
}

export function setMenuProperty(userAuth, menuID, property, value) {
  return set(ref(db, 'menus/' + menuID + '/' + property), value);
}

export async function fetchMenuByID(menuID) {
  let result = null

  await get(child(ref(db), `menus/${menuID}`)).then((snapshot) => {
    result = snapshot.val()

  }).catch(() => {
    return null
  });

  return result
}

export async function fetchUserData(uid) {
  let result = null

  await get(child(ref(db), `users/${uid}`)).then((snapshot) => {
    result = snapshot.val()

  }).catch((error) => {

    return null
  });

  return result
}

export async function getPaymentLink(userData, userID, provider, plan, frecuency) {

  if (plan === USER_PLANS.pro) {
    if (provider === USER_PAYMENT_PROVIDERS.mercadopago) {
      if (frecuency === USER_PAYMENTS_FRECUENCY.monthly) {

        if (userData.payments.pro.mercadopago.monthly.paymentLink !== '') {
          return userData.payments.pro.mercadopago.monthly.paymentLink
        }

      } else if (frecuency === USER_PAYMENTS_FRECUENCY.annual) {

        if (userData.payments.pro.mercadopago.annual.paymentLink !== '') {
          return userData.payments.pro.mercadopago.annual.paymentLink
        }
      }
    }
  }

  //No hay un link de pago previo tengo que generar otro
  const BACKEND_LINK = `https://us-central1-tukit00.cloudfunctions.net/getPaymentLink?userid=${userID}&provider=${provider}&plan=${plan}&frecuency=${frecuency}`

  return await fetch(BACKEND_LINK, {
    method: 'GET',
  }).then(res => res.json().then(obj => obj.paymentLink))
    .catch(err => null)
}

export async function updatePaymentStatusByUser(userID) {
  const BACKEND_LINK = `https://us-central1-tukit00.cloudfunctions.net/updatePaymentStatusByUser?userid=${userID}`

  return await fetch(BACKEND_LINK, {
    method: 'GET',
  }).then(res => res.json())
    .catch(err => null)
}

export function registerUser(user, menuID) {
  return set(ref(db, 'users/' + user.uid), createUser(menuID));
}

export function registerMenu(user, menuID) {
  return set(ref(db, 'menus/' + menuID), createMenu(user.uid, menuID));
}

export function updateStore(user, menuID, values) {
  return update(ref(db, 'menus/' + menuID), values)
}

export async function updateMenuID(user, menuData, newMenuID, prevMenuID) {
  return set(ref(db, 'menus/' + newMenuID), menuData)
    .then(
      update(ref(db, `users/${user.uid}`),
        {
          menuid: newMenuID
        })
        .then(
          set(ref(db, `menus/${prevMenuID}/`), null)
        )
    )

  //duplicar el menu con el nuevo ID
  //modificar el menuid en users
  //eliminar el menu anterior
}